<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Gönderilecek Mail</label>
            <v-validator :errors="errors" parameter="value.ToMail" :watch="ToMail">
                 <input type="test" class="form-control" v-model="value.ToMail" placeholder="Gönderilecek Mail"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object,
        errors:Object
    }
}
</script>